import styled from "styled-components";

export default styled.div.attrs(props => ({

}))`
    text-align: left;


    h4 {
        font-size: 24px;
        font-weight: 600;
        line-height: normal;
        letter-spacing: -0.84px;
    }

    ul {
        font-size: 14px;
        line-height: 1.4;
        margin-bottom: 0;

        > li {
            margin-bottom: 0;
        }
    }

`